module.exports = __webpack_public_path__ + "static/media/novartis_logo_pos_rgb.3476bd8d.png";